import React from "react";
import { Route, Redirect } from "react-router-dom";
import Layout from "../../layout/userlayout/layout.component";
import jwtDecode from "jwt-decode";

const RegRoute = ({ component: Component, ...rest }) => {
  let valid = rest.state.isValid;
  let mobile_number = rest.phone;
  let userData = null;
  try {
    userData = rest.state.payload ? jwtDecode(rest.state.payload) : null;
  } catch (err) {
    console.error("Token decoding failed in RegRoute:", err);
  }

  const user = userData?.user || userData;
  const userType = user?.user_type;
  
  console.log("RegRoute UserType:", userType);
  return (
    <Route
      {...rest}
      render={(props) =>
        valid || userType === 21 || userType === 4 || userType === 20 || userType === 27 ? (
          <Layout
            {...props}
            {...rest}
            key={rest.location?.key}
            mobile_number={rest.phone}
          >
            <Component
              {...props}
              {...rest}
              mobile_number={rest.phone}
              key={rest.location?.key}
            />
          </Layout>
        ) : (
          <Redirect to="/registration" />
        )
      }
    />
  );
};

export default RegRoute;
